import { pushEvent } from '../../../client/data-layer';

export const trackChangelogOpened = () => {
  pushEvent('changelogOpened');
};

export const trackChangelogArticleViewed = ({ id }: { id: string }) => {
  pushEvent('changelogArticleViewed', { id });
};

export const trackChangelogArticlesListed = ({ page }: { page: number }) => {
  pushEvent('changelogArticlesListed', { page });
};
